import { useState, useEffect } from "react";

/**
 * Fetches poems from a given URL and returns a state object with the poems
 * loaded, a boolean indicating whether the poems are currently loading, and
 * an error if there was a problem loading the poems.
 *
 * @param {string} [url=/poem_selection.json] The URL to fetch the poems from.
 * @returns {{
 *   poems: Array.<{title: string, author: string, text: string}>,
 *   loading: boolean,
 *   error: Error|null
 * }}
 */
export function usePoems(url = "/poem_selection.json") {
  const [poems, setPoems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log(`[usePoems] Fetching poems from: ${url}`);
    setLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (data && Array.isArray(data.poems)) {
          setPoems(data.poems);
        } else {
          setPoems([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [url]);

  return { poems, loading, error };
}
